import React from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  CardActionArea,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
  Chip,
  Avatar,
  Grid,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import { compose } from 'recompose';
import AccessTimeOutlinedIcon from '@material-ui/icons/AccessTimeOutlined';
import { ICON_COLOR_STYLE_NAMES } from 'Utils/customStyling';

const styles = theme => ({
  root: {
    borderRadius: 8,
    boxShadow: '2px 3px 16px 0 rgba(0, 0, 0, 0.04)',
  },
  highlightRoot: {
    borderRadius: 8,
    borderStyle: 'solid',
    borderWidth: 2,
    borderColor: '#169cff',
    boxShadow: '3px 5px 16px 0 rgba(53, 53, 255, 0.12)',
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
  },
  flexContentPrimary: {
    flex: '2 1 0',
    padding: '7px 0 7px 0',
  },
  flexContentSecondary: {
    flex: '1 1 0',
    padding: '7px 0 7px 0',
  },
  showSkeleton: {
    opacity: '0.7',
    borderRadius: '2.3px',
    backgroundImage: 'linear-gradient(to right, #d2d2d2, #ffffff)',
    color: 'transparent',
  },
  listItemAvatar: {
    borderRadius: 12,
    fontSize: '14px',
    color: '#fff',
    background: 'linear-gradient(315deg, #00cdcd, #009e9f)',
  },
  timeIcon: {
    width: '10px',
    height: '10px',
  },
  timeText: {
    fontSize: '11px',
    paddingLeft: '4px',
  },
});

class PersonListItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      nameAvatar: 'AA',
      avatarColor: '',
    };
    this.handleClick = this.handleClick.bind(this);
    this.getAvatar = this.getAvatar.bind(this);
  }

  componentDidMount() {
    const { name } = this.props;
    this.getAvatar(name);
    this.getColorGradient();
  }

  componentDidUpdate(prevProps) {
    const { loading, name } = this.props;
    if (prevProps.loading !== loading && !loading) {
      this.getAvatar(name);
      this.getColorGradient();
    }
  }

  handleClick(personId) {
    this.props.handleSelection(personId);
  }

  getAvatar(name) {
    if (name) {
      var nameSplit = name.split(' ');
      var nameIcon = '';
      for (var i = 0; i < nameSplit.length; i++) {
        nameIcon += nameSplit[i].charAt(0);
        if (i === 1) {
          break;
        }
      }
      this.setState({ nameAvatar: nameIcon });
    }
  }

  getStatusStyle(status) {
    switch (status) {
      case 'OPEN':
        return ICON_COLOR_STYLE_NAMES.ICON_COLOR_STYLE_ORANGE;
      case 'RENEGE':
        return ICON_COLOR_STYLE_NAMES.ICON_COLOR_STYLE_RED;
      case 'ONBOARDED':
        return ICON_COLOR_STYLE_NAMES.ICON_COLOR_STYLE_GREEN;
      case 'ACTIVE':
        return ICON_COLOR_STYLE_NAMES.ICON_COLOR_STYLE_GREEN;
      case 'INACTIVE':
        return ICON_COLOR_STYLE_NAMES.ICON_COLOR_STYLE_GREY;
    }
  }
  getColorGradient() {
    var hexValues = [
      '0',
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
      'a',
      'b',
      'c',
      'd',
      'e',
      'f',
    ];

    function populate(a) {
      for (var i = 0; i < 6; i++) {
        var x = Math.round(Math.random() * 14);
        var y = hexValues[x];
        a += y;
      }
      return a;
    }

    var newColor1 = populate('#');
    // var newColor2 = populate('#');
    var angle = 315;

    var gradient =
      'linear-gradient(' + angle + 'deg, ' + newColor1 + ', ' + newColor1 + ')';
    this.setState({ avatarColor: gradient });
  }

  render() {
    let {
      classes,
      selected,
      name,
      designation,
      personId,
      hrName,
      allowance,
      status,
      createdAt,
      loading,
      isUser,
      email,
      access,
      ...otherProps
    } = this.props;
    name = name && name.length > 20 ? name.substring(0, 20) + '...' : name;
    designation =
      designation && designation.length > 20
        ? designation.substring(0, 20) + '...'
        : designation;
    email = email && email.length > 20 ? email.substring(0, 20) + '...' : email;
    hrName =
      hrName && hrName.length > 20 ? hrName.substring(0, 20) + '...' : hrName;
    const { nameAvatar, avatarColor } = this.state;
    return (
      <Card
        className={classNames(
          selected && !loading ? classes.highlightRoot : classes.root,
          'contentMarginTop'
        )}
        {...otherProps}
      >
        <CardActionArea
          disableRipple
          disableTouchRipple
          onClick={() => this.handleClick(personId)}
        >
          <Toolbar>
            <List
              className={classNames(classes.flexRow, 'fullWidth')}
              disablePadding
            >
              <ListItem className={classes.flexContentPrimary} key={personId}>
                <ListItemIcon>
                  <Avatar
                    className={
                      loading ? classes.showSkeleton : classes.listItemAvatar
                    }
                    style={{
                      background: !loading ? avatarColor : '',
                    }}
                  >
                    {loading ? 'AA' : nameAvatar}
                  </Avatar>
                </ListItemIcon>
                <ListItemText
                  classes={{
                    primary: loading ? classes.showSkeleton : '',
                    secondary: loading ? classes.showSkeleton : '',
                  }}
                  primary={!loading ? name : 'dummy'}
                  secondary={!loading ? designation : 'dummy'}
                />
              </ListItem>
              <ListItem className={classes.flexContentPrimary}>
                <ListItemText
                  primary={
                    <Typography
                      variant="body2"
                      component="p"
                      color="textSecondary"
                      className={loading ? classes.showSkeleton : ''}
                    >
                      {isUser ? 'Email Id' : 'HR Partner'}
                    </Typography>
                  }
                  secondary={
                    <Typography
                      variant="body1"
                      component="span"
                      className={loading ? classes.showSkeleton : ''}
                    >
                      {!loading ? email || hrName : 'dummy'}
                    </Typography>
                  }
                />
              </ListItem>
              <ListItem className={classes.flexContentSecondary}>
                <ListItemText
                  primary={
                    <Typography
                      variant="body2"
                      component="p"
                      color="textSecondary"
                      className={loading ? classes.showSkeleton : ''}
                    >
                      {isUser ? 'Access' : 'Budget'}
                    </Typography>
                  }
                  secondary={
                    <Typography
                      variant="body1"
                      component="span"
                      className={loading ? classes.showSkeleton : ''}
                    >
                      {!isUser ? 'INR ' : ''}
                      {!loading ? allowance || access : 'dummy'}
                    </Typography>
                  }
                />
              </ListItem>
              <ListItem className={classes.flexContentSecondary}>
                <ListItemText
                  primary={
                    <Chip
                      size="small"
                      fontSize="10px"
                      label={!loading ? status : 'OPEN'}
                      className={
                        loading
                          ? classes.showSkeleton
                          : this.getStatusStyle(status)
                      }
                    />
                  }
                  secondary={
                    !isUser ? (
                      <Grid container alignItems="center">
                        <AccessTimeOutlinedIcon
                          className={
                            loading ? classes.showSkeleton : classes.timeIcon
                          }
                        />
                        <Typography
                          className={
                            loading ? classes.showSkeleton : classes.timeText
                          }
                          variant="body2"
                          component="p"
                          color="textSecondary"
                        >
                          {createdAt}
                        </Typography>
                      </Grid>
                    ) : null
                  }
                />
              </ListItem>
            </List>
          </Toolbar>
        </CardActionArea>
      </Card>
    );
  }
}

PersonListItem.defaultProps = {
  hrName: '',
  allowance: '',
  status: '',
  createdAt: '',
  email: '',
  access: '',
};

PersonListItem.propTypes = {
  classes: PropTypes.object.isRequired,
  selected: PropTypes.bool,
  name: PropTypes.string.isRequired,
  designation: PropTypes.string.isRequired,
  personId: PropTypes.string.isRequired,
  hrName: PropTypes.string,
  allowance: PropTypes.number,
  status: PropTypes.string,
  createdAt: PropTypes.string,
  email: PropTypes.string,
  access: PropTypes.string,
  loading: PropTypes.bool.isRequired,
  isUser: PropTypes.bool.isRequired,
  handleSelection: PropTypes.func.isRequired,
};

PersonListItem = compose(withStyles(styles, { withTheme: true }))(
  PersonListItem
);

export { PersonListItem };
